import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MopedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"moped"}/>
}
